import { render } from "./ValueView.vue?vue&type=template&id=a880fc04"
import script from "./ValueView.vue?vue&type=script&lang=js"
export * from "./ValueView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__